<div class="day"  >
    <!-- <div tabindex="0" class="date" (click)="selectedDate(date)"
        [ngClass]="{currentday: date.date==today && date.month== month && date.year==year,focus:selecteddate==date && date!=='',padding:date.date<today && date.month== month && date.year==year}"> -->
            <div tabindex="0" class="date" (click)="selectedDate(date)"
            [ngClass]="{currentday: date.date==today && date.month== month && date.year==year,focus:selecteddate==date && date!==''}">
            {{date.date}}

    </div>

</div>